var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
var cls = classNames('dotted-line');
export var DottedLineDefaultProps = {
  height: 2,
  colors: {
    border: 'line'
  },
  gap: 6
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 0;\n    border: none;\n    display: block;\n    ", "\n  "], ["\n    font-size: 0;\n    border: none;\n    display: block;\n    ", "\n  "])), function (_a) {
    var _direction = _a._direction,
      _size = _a._size,
      colors = _a.colors,
      gap = _a.gap;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", ";\n      width: ", ";\n      ", ";\n    "], ["\n      height: ", ";\n      width: ", ";\n      ", ";\n    "])), _direction === 'horizontal' ? "".concat(_size, "px") : '100%', _direction === 'vertical' ? "".concat(_size, "px") : '100%', theme.DOT_BG(_direction === 'horizontal' ? 'h' : 'v', colors.border, _size, gap));
  })
});
// -------- Components -------->
var My = {
  Container: styled.hr(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var DottedLine = function (props) {
  var className = props.className,
    colors = props.colors,
    gap = props.gap;
  var direction = props.width === undefined ? 'horizontal' : 'vertical';
  var size = props.width === undefined ? props.height : props.width;
  return React.createElement(My.Container, {
    _size: size,
    _direction: direction,
    colors: colors,
    gap: gap,
    className: cls.name(className)
  });
};
DottedLine.cls = cls;
DottedLine.defaultProps = DottedLineDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;